import Keycloak from 'keycloak-js'
import { omit } from 'remeda'

const KEYCLOAK_PARAMS = ['state', 'session_state', 'code', 'iss']

export default defineNuxtPlugin({
  name: 'keycloakjs',
  enforce: 'pre',
  hooks: {
    'app:mounted'() {
      const router = useRouter()

      const query = omit(router.currentRoute.value.query, KEYCLOAK_PARAMS)
      router.replace({ query })
    }
  },
  async setup() {
    const config = useRuntimeConfig()

    try {
      const keycloak = new Keycloak({
        url: config.public.keycloakUrl as string,
        realm: config.public.keycloakRealm as string,
        clientId: config.public.keycloakClientId as string
      })

      await keycloak.init({
        onLoad: 'check-sso',
        silentCheckSsoRedirectUri: window.location.origin + '/silent-check-sso.html',
        checkLoginIframe: false
      })

      return {
        provide: {
          keycloak
        }
      }
    } catch (e) {
      console.error(e)
      throw createError({ statusCode: 401, message: 'Keycloak error' })
    }
  }
})
